import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// 适配
import 'lib-flexible'

// vant
import { Form, NoticeBar, Field, Button, Icon } from 'vant'
Vue.use(Form).use(NoticeBar).use(Field).use(Button).use(Icon)

// vue-luck-draw
import LuckDraw from 'vue-luck-draw'
Vue.use(LuckDraw)

// qs
import qs from 'qs'
Vue.prototype.$qs = qs

// axios
import axios from 'axios'
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'https://api.hemutx.com/' : 'http://api.daimi360.com/'
// axios.defaults.baseURL = 'http://api.daimi360.com/'
axios.defaults.timeout = 10 * 1000
axios.interceptors.request.use(
    (config) => {
        config.headers = {
			'Content-Type': 'application/x-www-form-urlencoded',
            ...config.headers
		}
        return config
    },
    (err) => {
        return Promise.reject(err)
    }
)
// axios.interceptors.response.use(
//     response => {},
//     error => {}
// )
Vue.prototype.$axios = axios

// utils
import utils from './utils'
Vue.use(utils)

// 导航守卫
router.beforeEach((to, from, next) => {
	next()
})
router.afterEach((to) => {
	window.document.title = to.name + ' - 赤乐川做好牛羊料'
})

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
